import { CommonConstant } from "shared/constants/common-constant"
import { Link, useNavigate } from "react-router-dom"
import { rootStore, useStores } from "stores/root-store"
import { CommonHyperlink, CustomDataGrid } from "components/common-styles"
import { Card, CardContent, CardHeader } from "@mui/material"
import { useEffect, useState } from "react"
import { format } from "date-fns"
import { GridToolbarContainer } from "@mui/x-data-grid"
import CustomExportButton from "components/common/custom-export-button"

function CustomToolbarOrder(props) {
  return (
    <GridToolbarContainer>
      <CustomExportButton exportOptions={props.exportOptions} />
    </GridToolbarContainer>
  )
}

const SaleOrderProductInfo = () => {
  const navigate = useNavigate()
  const { SaleOrderStore } = useStores()
  const products = [...SaleOrderStore.deliveryInfo?.products]
  const [exportFileName, setExportFileName] = useState("")

  const handleCellClicked = params => {
    if (params.field === "product") {
      navigate(`/products/${encodeURIComponent(params.row["product"])}`)
    }
  }

  const columns = [
    {
      field: "line_num",
      headerName: "No.",
      renderCell: params => Number(params.value).toFixed(3),
    },
    {
      field: "product",
      headerName: "Product",
      minWidth: 200,
      flex: 1,
      renderCell: params => <CommonHyperlink>{params.value}</CommonHyperlink>,
    },
    {
      field: "product_description",
      headerName: "Description",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "qty",
      headerName: "Qty",
      type: "number",
      width: 80,
    },
    {
      field: "price",
      headerName: "Price",
      width: 120,
      type: "number",
      renderCell: params => `$${params.value}`,
    },
    {
      field: "country_of_origin",
      headerName: "Country of Origin",
      width: 150,
      renderCell: params => rootStore.getTextByValue("COUNTRY", params.value),
    },
    {
      field: "original_order_id",
      headerName: "Original Order Number",
      width: 150,
    },
    {
      field: "customer_po",
      headerName: "Original Ship To",
      width: 150,
    },
  ]

  useEffect(() => {
    const pathNames = location.hash.split("/").filter(x => x && x != "#")
    const shipmentId = decodeURIComponent(pathNames.length > 1 ? pathNames[1] : "")
    setExportFileName(`Express_SaleOrder_Product.${shipmentId}-${format(new Date(), "ddMMyyyy.HHmm")}`)
  }, [])

  return (
    <Card id="cardProducts">
      <CardHeader title="Product Information" />
      <CardContent>
        {!products || products.length == 0 ? (
          <></>
        ) : (
          <CustomDataGrid
            getRowId={row => row.line_id}
            rows={products.filter(x => x.action !== "DELETE")}
            columns={columns}
            initialState={{
              sorting: {
                sortModel: [{ field: "line_num", sort: CommonConstant.ASCENDING }],
              },
              pagination: {
                paginationModel: {
                  pageSize: 15,
                },
              },
            }}
            pageSizeOptions={[10, 15, 20, 50]}
            onCellClick={handleCellClicked}
            slots={{
              toolbar: CustomToolbarOrder,
            }}
            slotProps={{
              toolbar: {
                exportOptions: { hiddenColumns: {}, columns: columns, fileName: exportFileName, data: products.filter(x => x.action !== "DELETE") },
              },
            }}
          />
        )}
      </CardContent>
    </Card>
  )
}

export default SaleOrderProductInfo
